import PropTypes from 'prop-types';

import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { List } from 'immutable';

import { createBlock } from '../EditorContainer/actions';

import EditorAdd from '../../components/EditorAdd';

import { selectAllowedBlockTypes } from '../EditorContainer/selectors';

const ITEMS = List([
  {
    id: 'TEXT',
    title: 'Текст',
  },
  {
    id: 'COLLAPSE',
    title: 'Спойлер',
  },
  {
    id: 'QUOTE',
    title: 'Цитата',
  },
  {
    id: 'IMAGE',
    title: 'Изображение',
  },
  {
    id: 'VIDEO',
    title: 'Видео',
  },
  {
    id: 'GALLERY',
    title: 'Галерея',
  },
  {
    id: 'AR',
    title: 'AR',
  },
  {
    id: 'WIDGET',
    title: 'Виджет',
  },
]);

export class EditorAddContainer extends React.PureComponent {
  constructor(props) {
    super(props);

    this._handlers = {
      onOpen: this.handleOpen,
      onClose: this.handleClose,
      onCreateBlock: this.handleCreateBlock,
    };

    this.handleOpen = this._buildHandler('onOpen');
    this.handleClose = this._buildHandler('onClose');
    this.handleCreateBlock = this._buildHandler('onCreateBlock');

    this.state = {
      isOpen: false,
    };
  }

  get items() {
    const { allowedBlockTypes } = this.props;
    return allowedBlockTypes && allowedBlockTypes.size
      ? ITEMS.filter((item) => allowedBlockTypes.includes(item.id))
      : ITEMS;
  }

  handleOpen = () => this.setState({ isOpen: true });

  handleClose = () => this.setState({ isOpen: false });

  handleCreateBlock = (blockType, index) => {
    this.props.createBlock(blockType, index);
    this.handleClose();
  };

  _buildHandler =
    (eventName) =>
    (...args) => {
      if (!this.props.readOnly) {
        const method = this._handlers[eventName];
        if (method) {
          method(...args);
        }
      }
    };

  render() {
    return (
      <EditorAdd
        items={this.items}
        isOpen={this.state.isOpen}
        index={this.props.index}
        onOpen={this.handleOpen}
        onClose={this.handleClose}
        onCreateBlock={this.handleCreateBlock}
      />
    );
  }
}

EditorAddContainer.propTypes = {
  allowedBlockTypes: PropTypes.instanceOf(List),
  index: PropTypes.number,
  readOnly: PropTypes.bool,

  createBlock: PropTypes.func,
};

const mapStateToProps = createStructuredSelector({
  allowedBlockTypes: selectAllowedBlockTypes(),
});

function mapDispatchToProps(dispatch) {
  return {
    createBlock: (type, index) => {
      dispatch(createBlock(type, index));
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EditorAddContainer);
